import {
  Component,
  ComponentInterface,
  ComponentWillLoad,
  Element,
  h,
  Listen,
  Prop,
} from "@stencil/core"
import { FP } from "../../deps"

import * as Events from "../../events/events"
import { MonetaryAmount } from "../../service-sellalong/service-sellalong"
import * as Theme from "../../theme/theme"

@Component({
  tag: "sellalong-cta",
  scoped: true,
  styleUrls: {
    theme_8629350: "./sellalong-cta-theme-sirplus.css",
    theme_27219324: "./sellalong-cta-theme-bmo.css",
    theme_53156151463: "./sellalong-cta.css",
  },
})
export class CTA implements ComponentInterface, ComponentWillLoad {
  @Element()
  element!: HTMLElement

  private theme!: Theme.Theme

  /**
   * Current sellalong discount amount applied to the cart - displayed to the user if provided
   */
  @Prop()
  discountAmount: MonetaryAmount | null = null

  /**
   * The max amount of credit available to the customer. Only displayed if exceeds the `ctaMaxCreditDisplayThreshold`
   * setting in theme settings. If not provided, component will not render.
   */
  @Prop()
  maxCreditAvailable: MonetaryAmount | null = null

  async componentWillLoad() {
    this.theme = await Theme.loadTheme(this.element)()
  }

  @Listen("click")
  handleClick(event: Event) {
    event.preventDefault()

    const panelElement = document.getElementById(
      "sellalong"
    ) as HTMLSellalongPanelElement

    if (panelElement && typeof panelElement["scrollToElement"] === "function") {
      panelElement.scrollToElement()
    }

    Events.publish({ kind: "sellalongCtaIntent" })
  }

  disconnectedCallback() {
    Events.publish({ kind: "sellalongComponentRemovedInternal" })
  }

  render() {
    const { settings, text } = this.theme
    const { discountAmount, maxCreditAvailable } = this

    const ctaActionClasses = FP.function.pipe(
      settings.ctaActionClasses,
      FP.readonlyArray.reduce(
        {
          "sellalong-cta-action": true,
        } as Record<string, boolean>,
        (acc, curr) => FP.readonlyRecord.upsertAt(curr, true)(acc)
      )
    )

    if (discountAmount !== null && discountAmount.value > 0) {
      return (
        <a href="#sellalong" class="sellalong-cta-link">
          {text("ctaCurrentCredit")({
            credit: discountAmount,
          })}
          <span class={ctaActionClasses}>{text("ctaCurrentCreditLink")}</span>
        </a>
      )
    }

    if (!maxCreditAvailable) {
      return null
    }

    const leadingText = text("ctaLeading")

    return (
      <a href="#sellalong" class="sellalong-cta-link">
        {leadingText}
        {leadingText !== null ? <br /> : null}
        {text("ctaMain")({
          maxCreditDisplayThreshold: settings.ctaMaxCreditDisplayThreshold,
          maxCredit: maxCreditAvailable,
        })}
        <span class={ctaActionClasses}>{text("ctaLink")}</span>
      </a>
    )
  }
}
